import { Component, computed, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

import { PortalLayoutComponent } from './layout/portal/portal-layout.component';
import { PublicLayoutComponent } from './layout/public/public-layout.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [PortalLayoutComponent, PublicLayoutComponent],
  template: `
    @if (isPublicRoute()) {
      <app-public-layout />
    } @else {
      <app-portal-layout />
    }
  `
})
export class AppComponent {
  readonly router = inject(Router);
  private readonly currentUrl = signal(this.router.url);

  constructor() {
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
      this.currentUrl.set(event.urlAfterRedirects);
    });
  }

  readonly isPublicRoute = computed(() => {
    const url = this.currentUrl();
    return url === '/login' || url === '/forgot-password' || url === '/register' || url.startsWith('/register/');
  });

}
